import React from "react";
import AppShell from "../components/layout/AppShell";
import AppFooter from "../components/layout/AppFooter";
import TopNav from "../components/layout/TopNav";

export default function Legal({ onNavigate, isLoggedIn, onLogout }) {
    return (
        <AppShell
            header={<TopNav isLoggedIn={isLoggedIn} onLogout={onLogout} onNavigate={onNavigate} />}
            footer={<AppFooter onNavigate={onNavigate} />}
            onNavigate={onNavigate}
        >
            <div style={{ maxWidth: 780, margin: "0 auto", padding: "40px 24px 80px" }}>
                <button
                    onClick={() => onNavigate("home")}
                    style={{
                        background: "none", border: "none", color: "rgba(180,180,200,0.75)",
                        fontSize: 13, cursor: "pointer", padding: 0, marginBottom: 28,
                        display: "flex", alignItems: "center", gap: 6,
                    }}
                >
                    ← Retour
                </button>

                <h1 style={{ fontSize: 28, fontWeight: 800, letterSpacing: "-0.025em", marginBottom: 6 }}>
                    Mentions légales
                </h1>
                <p style={{ color: "rgba(180,180,200,0.65)", fontSize: 13, marginBottom: 48 }}>
                    Dernière mise à jour : {new Date().toLocaleDateString("fr-FR", { year: "numeric", month: "long", day: "numeric" })}
                </p>

                {[
                    {
                        title: "1. Éditeur du site",
                        content: [
                            "Le site Solvya est édité par :",
                            "Raison sociale : [À COMPLÉTER — SAS Solvya]",
                            "Forme juridique : Société par Actions Simplifiée (SAS) — en cours de création",
                            "Capital social : [À COMPLÉTER]",
                            "Siège social : [À COMPLÉTER — adresse]",
                            "SIRET : [À COMPLÉTER]",
                            "RCS : [À COMPLÉTER]",
                            "Email : contact@solvya.io",
                            "Directeur de la publication : [À COMPLÉTER — Prénom Nom]",
                        ]
                    },
                    {
                        title: "2. Hébergement",
                        content: [
                            "Le site est hébergé par :",
                            "Hébergeur : OVH",
                            "Adresse : [À COMPLÉTER]",
                            "Site web : solvya.io",
                        ]
                    },
                    {
                        title: "3. Propriété intellectuelle",
                        content: [
                            "L'ensemble du contenu de ce site (textes, images, logos, icônes, code source) est la propriété exclusive de Solvya ou de ses partenaires et est protégé par les lois françaises et internationales relatives à la propriété intellectuelle.",
                            "Toute reproduction, représentation, modification, publication ou adaptation, totale ou partielle, de l'un quelconque des éléments du site est interdite sans autorisation écrite préalable de Solvya.",
                        ]
                    },
                    {
                        title: "4. Données personnelles",
                        content: [
                            "Solvya collecte et traite des données personnelles dans le cadre de la fourniture de ses services. Ces traitements sont effectués conformément au Règlement Général sur la Protection des Données (RGPD — Règlement UE 2016/679) et à la loi Informatique et Libertés.",
                            "Pour en savoir plus sur la collecte et l'utilisation de vos données, consultez notre Politique de confidentialité.",
                            "Vous disposez d'un droit d'accès, de rectification, d'effacement, de portabilité et d'opposition concernant vos données personnelles. Pour exercer ces droits, contactez-nous à : [À COMPLÉTER — contact@solvya.io].",
                        ]
                    },
                    {
                        title: "5. Cookies",
                        content: [
                            "Le site Solvya utilise des cookies strictement nécessaires au fonctionnement du service (authentification, session). Aucun cookie publicitaire ou de tracking tiers n'est utilisé.",
                        ]
                    },
                    {
                        title: "6. Limitation de responsabilité",
                        content: [
                            "Solvya s'efforce d'assurer l'exactitude et la mise à jour des informations publiées sur ce site. Cependant, Solvya ne peut garantir l'exactitude, la complétude ou l'actualité des informations diffusées.",
                            "Solvya décline toute responsabilité pour tout dommage direct ou indirect résultant de l'utilisation du site ou de l'impossibilité d'y accéder.",
                        ]
                    },
                    {
                        title: "7. Droit applicable",
                        content: [
                            "Les présentes mentions légales sont soumises au droit français. Tout litige relatif à l'utilisation du site sera soumis à la compétence exclusive des tribunaux français.",
                        ]
                    },
                    {
                        title: "8. Contact",
                        content: [
                            "Pour toute question relative aux présentes mentions légales, vous pouvez nous contacter à l'adresse suivante :",
                            "Email : contact@solvya.io",
                        ]
                    },
                ].map((section) => (
                    <div key={section.title} style={{ marginBottom: 40 }}>
                        <h2 style={{
                            fontSize: 16, fontWeight: 700, letterSpacing: "-0.01em",
                            marginBottom: 14, paddingBottom: 10,
                            borderBottom: "1px solid rgba(255,255,255,0.07)"
                        }}>
                            {section.title}
                        </h2>
                        {section.content.map((line, i) => (
                            <p key={i} style={{
                                fontSize: 14, lineHeight: 1.7,
                                color: line.startsWith("[À COMPLÉTER")
                                    ? "rgba(245,158,11,0.85)"
                                    : "rgba(200,200,215,0.85)",
                                margin: "0 0 8px",
                            }}>
                                {line}
                            </p>
                        ))}
                    </div>
                ))}
            </div>
        </AppShell>
    );
}